(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Message', Message);

    Message.$inject = ['$resource'];


    function Message ($resource) {
        var resourceUrl =  'api/messages/:discussionId';

        return $resource(resourceUrl, {}, {
            'create': {
                method:'POST',
                url:'api/messages/:discussionId'
            },
            'messageRequestExternalNetwork': {
                method: 'POST',
                url: 'api/messageRequestExternalNetwork'
            },
            'envoyerMessageCommercial': {
                method: 'POST',
                url: 'api/envoyerMessageCommercial/:commercialUserId'
            },
            'envoyerMessageLibre': {
                method: 'POST',
                url: 'api/envoyerMessageLibre/:userId'
            },
            'envoyerMessageRectifyProfile': {
                method: 'POST',
                url: 'api/envoyerMessageRectifyProfile/:profileId'
            },
            'query': {
                method:'GET',
                url:'api/messages/:discussionId',
                isArray: true
            }
        });
    }
})();
